"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spacer = exports.RightContent = exports.LeftContent = exports.Wrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helperFunctions = require("../../../styles/helperFunctions");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "ResponsiveTwoThirdsSplitstyles__Wrapper",
  componentId: "wf467v-0"
})(["display:flex;flex-direction:column;width:100%;@media only screen and (min-width:", "){flex-direction:row;}"], function (props) {
  return props.theme.mediumBreak;
});

exports.Wrapper = Wrapper;

var LeftContent = _styledComponents.default.div.withConfig({
  displayName: "ResponsiveTwoThirdsSplitstyles__LeftContent",
  componentId: "wf467v-1"
})(["width:100%;display:flex;word-break:break-word;@media only screen and (min-width:", "){justify-content:", ";width:66%;}"], function (props) {
  return props.theme.mediumBreak;
}, function (props) {
  return props.selfAlignment ? (0, _helperFunctions.flexAlign)(props.selfAlignment) : 'initial';
});

exports.LeftContent = LeftContent;

var RightContent = _styledComponents.default.div.withConfig({
  displayName: "ResponsiveTwoThirdsSplitstyles__RightContent",
  componentId: "wf467v-2"
})(["width:100%;display:flex;word-break:break-word;@media only screen and (min-width:", "){justify-content:", ";width:33%;}"], function (props) {
  return props.theme.mediumBreak;
}, function (props) {
  return props.selfAlignment ? (0, _helperFunctions.flexAlign)(props.selfAlignment) : 'initial';
});

exports.RightContent = RightContent;

var Spacer = _styledComponents.default.div.withConfig({
  displayName: "ResponsiveTwoThirdsSplitstyles__Spacer",
  componentId: "wf467v-3"
})(["height:", ";min-height:", ";min-width:", ";width:", ";"], function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
}, function (props) {
  return (0, _helperFunctions.joinDimensions)('*', 2, props.theme.standardPadding);
});

exports.Spacer = Spacer;